/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'fr',
  Pagination: {
    items_per_page: '/ page',
    jump_to: 'Aller à',
    jump_to_confirm: 'confirmer',
    page: '',
    prev_page: 'Page précédente',
    next_page: 'Page suivante',
    prev_5: '5 Pages précédentes',
    next_5: '5 Pages suivantes',
    prev_3: '3 Pages précédentes',
    next_3: '3 Pages suivantes'
  },
  DatePicker: {
    lang: {
      placeholder: 'Sélectionner une date',
      yearPlaceholder: 'Sélectionner une année',
      quarterPlaceholder: 'Sélectionner un trimestre',
      monthPlaceholder: 'Sélectionner un mois',
      weekPlaceholder: 'Sélectionner une semaine',
      rangePlaceholder: ['Date de début', 'Date de fin'],
      rangeYearPlaceholder: ['Année de début', 'Année de fin'],
      rangeMonthPlaceholder: ['Mois de début', 'Mois de fin'],
      rangeWeekPlaceholder: ['Semaine de début', 'Semaine de fin'],
      locale: 'fr_FR',
      today: "Aujourd'hui",
      now: 'Maintenant',
      backToToday: "Aujourd'hui",
      ok: 'Ok',
      clear: 'Rétablir',
      month: 'Mois',
      year: 'Année',
      timeSelect: "Sélectionner l'heure",
      dateSelect: 'Sélectionner la date',
      monthSelect: 'Choisissez un mois',
      yearSelect: 'Choisissez une année',
      decadeSelect: 'Choisissez une décennie',
      yearFormat: 'YYYY',
      dateFormat: 'DD/MM/YYYY',
      dayFormat: 'DD',
      dateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mois précédent (PageUp)',
      nextMonth: 'Mois suivant (PageDown)',
      previousYear: 'Année précédente (Ctrl + gauche)',
      nextYear: 'Année prochaine (Ctrl + droite)',
      previousDecade: 'Décennie précédente',
      nextDecade: 'Décennie suivante',
      previousCentury: 'Siècle précédent',
      nextCentury: 'Siècle suivant'
    },
    timePickerLocale: {
      placeholder: "Sélectionner l'heure",
      rangePlaceholder: ['Heure de début', 'Heure de fin']
    }
  },
  TimePicker: {
    placeholder: "Sélectionner l'heure",
    rangePlaceholder: ['Heure de début', 'Heure de fin']
  },
  Calendar: {
    lang: {
      placeholder: 'Sélectionner une date',
      yearPlaceholder: 'Sélectionner une année',
      quarterPlaceholder: 'Sélectionner un trimestre',
      monthPlaceholder: 'Sélectionner un mois',
      weekPlaceholder: 'Sélectionner une semaine',
      rangePlaceholder: ['Date de début', 'Date de fin'],
      rangeYearPlaceholder: ['Année de début', 'Année de fin'],
      rangeMonthPlaceholder: ['Mois de début', 'Mois de fin'],
      rangeWeekPlaceholder: ['Semaine de début', 'Semaine de fin'],
      locale: 'fr_FR',
      today: "Aujourd'hui",
      now: 'Maintenant',
      backToToday: "Aujourd'hui",
      ok: 'Ok',
      clear: 'Rétablir',
      month: 'Mois',
      year: 'Année',
      timeSelect: "Sélectionner l'heure",
      dateSelect: 'Sélectionner la date',
      monthSelect: 'Choisissez un mois',
      yearSelect: 'Choisissez une année',
      decadeSelect: 'Choisissez une décennie',
      yearFormat: 'YYYY',
      dateFormat: 'DD/MM/YYYY',
      dayFormat: 'DD',
      dateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mois précédent (PageUp)',
      nextMonth: 'Mois suivant (PageDown)',
      previousYear: 'Année précédente (Ctrl + gauche)',
      nextYear: 'Année prochaine (Ctrl + droite)',
      previousDecade: 'Décennie précédente',
      nextDecade: 'Décennie suivante',
      previousCentury: 'Siècle précédent',
      nextCentury: 'Siècle suivant'
    },
    timePickerLocale: {
      placeholder: "Sélectionner l'heure",
      rangePlaceholder: ['Heure de début', 'Heure de fin']
    }
  },
  Table: {
    filterTitle: 'Filtrer',
    filterConfirm: 'OK',
    filterReset: 'Réinitialiser',
    selectAll: 'Sélectionner la page actuelle',
    selectInvert: 'Inverser la sélection de la page actuelle',
    selectionAll: 'Sélectionner toutes les données',
    sortTitle: 'Trier',
    expand: 'Développer la ligne',
    collapse: 'Réduire la ligne',
    triggerDesc: 'Trier par ordre décroissant',
    triggerAsc: 'Trier par ordre croissant',
    cancelSort: 'Annuler le tri'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Annuler',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Annuler'
  },
  Transfer: {
    searchPlaceholder: 'Rechercher',
    itemUnit: 'élément',
    itemsUnit: 'éléments'
  },
  Empty: {
    description: 'Aucune donnée'
  },
  Upload: {
    uploading: 'Téléchargement...',
    removeFile: 'Effacer le fichier',
    uploadError: 'Erreur de téléchargement',
    previewFile: 'Fichier de prévisualisation',
    downloadFile: 'Télécharger un fichier'
  },
  Text: {
    edit: 'Éditer',
    copy: 'Copier',
    copied: 'Copie effectuée',
    expand: 'Développer'
  },
  PageHeader: {
    back: 'Retour'
  }
};
